import BusinessCompanyForm from './BusinessCompanyForm';
import BusinessCompanyList from './BusinessCompanyList';

export {
    BusinessCompanyForm,
    BusinessCompanyList
};
